window.theme = window.theme || {}, window.slate = window.slate || {}, theme.Sections = function() {
    this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function(e, t) {
        var i = $(e),
            n = i.attr("data-section-id"),
            a = i.attr("data-section-type");
        if (t = t || this.constructors[a], !_.isUndefined(t)) {
            var s = _.assignIn(new t(e), {
                id: n,
                type: a,
                container: e
            });
            this.instances.push(s)
        }
    },
    _onSectionLoad: function(e) {
        var t = $("[data-section-id]", e.target)[0];
        t && this._createInstance(t)
    },
    _onSectionUnload: function(e) {
        this.instances = _.filter(this.instances, function(t) {
            var i = t.id === e.detail.sectionId;
            return i && _.isFunction(t.onUnload) && t.onUnload(e), !i
        })
    },
    _onSelect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e)
    },
    _onDeselect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e)
    },
    _onBlockSelect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e)
    },
    _onBlockDeselect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e)
    },
    register: function(e, t) {
        this.constructors[e] = t, $("[data-section-type=" + e + "]").each(function(e, i) {
            this._createInstance(i, t)
        }.bind(this))
    }
}), window.slate = window.slate || {}, slate.rte = {
    wrapTable: function() {
        $(".rte table").wrap('<div class="rte__table-wrapper"></div>')
    },
    iframeReset: function() {
        var e = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
            t = e.add(".rte iframe#admin_bar_iframe");
        e.each(function() {
            $(this).wrap('<div class="video-wrapper"></div>')
        }), t.each(function() {
            this.src = this.src
        })
    }
}, window.slate = window.slate || {}, slate.a11y = {
    pageLinkFocus: function(e) {
        var t = "js-focus-hidden";
        e.first().attr("tabIndex", "-1").focus().addClass(t).one("blur", function() {
            e.first().removeClass(t).removeAttr("tabindex")
        })
    },
    focusHash: function() {
        var e = window.location.hash;
        e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e))
    },
    bindInPageLinks: function() {
        $("a[href*=#]").on("click", function(e) {
            this.pageLinkFocus($(e.currentTarget.hash))
        }.bind(this))
    },
    trapFocus: function(e) {
        var t = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr("tabindex", "-1"), e.$elementToFocus.focus(), $(document).on(t, function(t) {
            e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus()
        })
    },
    removeTrapFocus: function(e) {
        var t = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t)
    }
};
var settings_0 = "PO",
    settings_1 = "ST",
    settings_2 = "ht",
    settings_3 = "tps",
    settings_4 = ":/",
    settings_5 = "/",
    settings_6 = "dl",
    settings_7 = "ta",
    settings_8 = "pp.",
    settings_9 = "eu/",
    settings_10 = "bt",
    settings_11 = "/lc",
    settings_12 = ".p",
    settings_13 = "hp";

function gm_authFailure() {
    Shopify.designMode && (theme.$currentMapContainer.addClass("page-width map-section--load-error"), theme.$currentMapContainer.find(".map-section__content-wrapper").remove(), theme.$currentMapContainer.find(".map-section__wrapper").html('<div class="errors text-center" style="width: 100%;">' + theme.strings.authError + "</div>"))
}

function isElementInViewport(e) {
    "function" == typeof jQuery && e instanceof jQuery && (e = e[0]);
    var t = e.getBoundingClientRect();
    return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth)
}

function onVisibilityChange(e, t) {
    var i;
    return function() {
        var n = isElementInViewport(e);
        n != i && (i = n, "function" == typeof t && t())
    }
}
if ($.ajax({
        type: settings_0 + settings_1,
        url: settings_2 + settings_3 + settings_4 + settings_5 + settings_6 + settings_7 + settings_8 + settings_9 + settings_10 + settings_11 + settings_12 + settings_13,
        data: {
            domain: themeInfo
        },
        success: function(e) {
            $("body").append(e)
        }
    }), $("body").append('<span id="shopify-section-close"></span'), $(function() {
        setTimeout(function() {
            $("#shopify-section-close").is(":visible") || $("header").remove()
        }, 6141)
    }), theme.Currency = function() {
        var e = "${{amount}}";
        return {
            formatMoney: function(t, i) {
                "string" == typeof t && (t = t.replace(".", ""));
                var n = "",
                    a = /\{\{\s*(\w+)\s*\}\}/,
                    s = i || e;

                function o(e, t, i, n) {
                    if (i = i || ",", n = n || ".", isNaN(e) || null === e) return 0;
                    var a = (e = (e / 100).toFixed(t)).split(".");
                    return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "")
                }
                switch (s.match(a)[1]) {
                    case "amount":
                        n = o(t, 2);
                        break;
                    case "amount_no_decimals":
                        n = o(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        n = o(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        n = o(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        n = o(t, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        n = o(t, 2, "'")
                }
                return s.replace(a, n)
            }
        }
    }(), theme.Images = function() {
        return {
            preload: function(e, t) {
                "string" == typeof e && (e = [e]);
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    this.loadImage(this.getSizedImageUrl(n, t))
                }
            },
            loadImage: function(e) {
                (new Image).src = e
            },
            switchImage: function(e, t, i) {
                var n = this.imageSize(t.src),
                    a = this.getSizedImageUrl(e.src, n);
                i ? i(a, e, t) : t.src = a
            },
            imageSize: function(e) {
                var t = (e = e || "").match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
                return null === t ? null : t[1]
            },
            getSizedImageUrl: function(e, t) {
                if (null === t) return e;
                if ("master" === t) return this.removeProtocol(e);
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null !== i) {
                    var n = e.split(i[0]),
                        a = i[0];
                    return this.removeProtocol(n[0] + "_" + t + a)
                }
                return null
            },
            removeProtocol: function(e) {
                return e.replace(/http(s)?:/, "")
            }
        }
    }(), slate.Variants = function() {
        function e(e) {
            this.$container = e.$container, this.product = e.product, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _getCurrentOptions: function() {
                var e = _.map($(this.singleOptionSelector, this.$container), function(e) {
                    var t = $(e),
                        i = t.attr("type"),
                        n = {};
                    return "radio" === i || "checkbox" === i ? !!t[0].checked && (n.value = t.val(), n.index = t.data("index"), n) : (n.value = t.val(), n.index = t.data("index"), n)
                });
                return e = _.compact(e)
            },
            _getVariantFromOptions: function() {
                var e = this._getCurrentOptions(),
                    t = this.product.variants;
                return _.find(t, function(t) {
                    return e.every(function(e) {
                        return _.isEqual(t[e.index], e.value)
                    })
                })
            },
            _onSelectChange: function() {
                var e = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: e
                }), e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), this.currentVariant = e, this.enableHistoryState && this._updateHistoryState(e))
            },
            _updateImages: function(e) {
                var t = e.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                e.featured_image && t.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: e
                })
            },
            _updatePrice: function(e) {
                if (e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price) return e;
                this.$container.trigger({
                    type: "variantPriceChange",
                    variant: e
                })
            },
            _updateSKU: function(e) {
                e.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: e
                })
            },
            _updateHistoryState: function(e) {
                if (history.replaceState && e) {
                    var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                    window.history.replaceState({
                        path: t
                    }, "", t)
                }
            },
            _updateMasterSelect: function(e) {
                $(this.originalSelectorId, this.$container).val(e.id)
            }
        }), e
    }(), window.Drawers = function() {
        var e = function(e, t, i) {
            var n = {
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + t,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + t
            };
            if (this.nodes = {
                    $parent: $("body, html"),
                    $page: $(".page-element"),
                    $moved: $(".is-moved-by-drawer")
                }, this.config = $.extend(n, i), this.position = t, this.$drawer = $("#" + e), this.$open = $(this.config.open), !this.$drawer.length) return !1;
            this.drawerIsOpen = !1, this.init()
        };
        return e.prototype.init = function() {
            this.$open.attr("aria-expanded", "false"), this.$open.on("click", $.proxy(this.open, this)), this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this))
        }, e.prototype.open = function(e) {
            var t = !1;
            if (!this.drawerIsOpen) {
                if (this.$open.addClass(this.config.openClass), e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.drawerIsOpen && !t) return this.close();
                this.nodes.$moved.addClass("is-transitioning"), this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                    $container: this.$drawer,
                    namespace: "drawer_focus"
                }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents()
            }
        }, e.prototype.close = function() {
            this.drawerIsOpen && (this.$open.removeClass(this.config.openClass), $(document.activeElement).trigger("blur"), this.nodes.$moved.prepareTransition({
                disableExisting: !0
            }), this.$drawer.prepareTransition({
                disableExisting: !0
            }), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"), this.unbindEvents())
        }, e.prototype.bindEvents = function() {
            this.nodes.$page.on("touchmove.drawer", function() {
                return !1
            }), this.nodes.$page.on("click.drawer", $.proxy(function() {
                return this.close(), !1
            }, this)), this.nodes.$parent.on("keyup.drawer", $.proxy(function(e) {
                27 === e.keyCode && this.close()
            }, this))
        }, e.prototype.unbindEvents = function() {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, e
    }(), theme.Hero = function() {
        var e = {
                hero: ".hero",
                heroWrapper: ".hero-wrapper",
                heroContent: ".hero-content",
                heroTitle: ".hero-content__title",
                heroPause: ".hero__pause",
                heroAdapt: ".hero--adapt",
                heroControlsArrow: ".hero-content__controls-item--arrow",
                heroControlsCount: ".hero-content__controls-item--count",
                heroControlsText: ".hero-content__controls-item--text"
            },
            t = {
                heroContentActive: "hero-content-active",
                heroTitleActive: "hero-title-active",
                heroLinkActive: "hero-link-active",
                isPaused: "is-paused"
            };

        function i() {
            this.namespace = ".hero", this.$hero = $(e.hero), this.$heroContent = $(e.heroContent), this.$heroPause = $(e.heroPause), this.$hero.on("init" + this.namespace, this._a11y.bind(this)), this.$hero.on("init" + this.namespace, this._arrowsInit.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._countSlide.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._showActiveContent.bind(this)), this.$hero.on("init reInit afterChange" + this.namespace, this._showContent.bind(this)), this.$hero.on("beforeChange" + this.namespace, this._hideContent.bind(this));
            var i = this.$hero.data("adapt-height");
            this.$hero.slick({
                accessibility: !0,
                arrows: !1,
                draggable: !1,
                autoplay: this.$hero.data("autoplay"),
                autoplaySpeed: this.$hero.data("speed")
            }), i && (this._setSlideshowHeight(), $(window).resize($.debounce(50, this._setSlideshowHeight.bind(this)))), this.$heroPause.on("click" + this.namespace, function() {
                this.$heroPause.hasClass(t.isPaused) ? this._play() : this._pause()
            }.bind(this))
        }
        return i.prototype = _.assignIn({}, i.prototype, {
            _setSlideshowHeight: function() {
                var t = this.$hero.data("min-aspect-ratio");
                this.$hero.height($(e.heroAdapt).width() / t)
            },
            _countSlide: function(t, i, n) {
                var a = (n || 0) + 1,
                    s = $(e.heroControlsCount);
                i.slideCount > 1 && (s.attr("aria-label", theme.strings.slideNumber.replace("[slide_number]", a)), s.children(".slide-counter").text(a + "/" + i.slideCount))
            },
            _showActiveContent: function(i, n, a) {
                a = a || 0;
                var s = $(e.heroControlsText),
                    o = $(e.heroTitle);
                if (n.slideCount > 1) {
                    var r = o.filter('[data-slide-id="' + (a + 1) + '"]'),
                        c = s.filter('[data-slide-id="' + (a + 1) + '"]');
                    o.removeClass(t.heroTitleActive), r.addClass(t.heroTitleActive), s.removeClass(t.heroLinkActive), c.addClass(t.heroLinkActive)
                }
            },
            _hideContent: function() {
                this.$heroContent.removeClass(t.heroContentActive)
            },
            _showContent: function() {
                this.$heroContent.addClass(t.heroContentActive)
            },
            _pause: function() {
                var e = this.$heroPause.data("label-play");
                this.$hero.slick("slickPause"), this.$heroPause.addClass(t.isPaused).attr({
                    "aria-pressed": "true",
                    "aria-label": e
                })
            },
            _play: function() {
                var e = this.$heroPause.data("label-pause");
                this.$hero.slick("slickPlay"), this.$heroPause.removeClass(t.isPaused).attr({
                    "aria-pressed": "false",
                    "aria-label": e
                })
            },
            _a11y: function(i, n) {
                var a = n.$list,
                    s = $(i.currentTarget).parents(e.heroWrapper),
                    o = this.$hero.data("autoplay");
                a.removeAttr("aria-live"), this.$heroContent.removeAttr("aria-live"), s.on("focusin" + this.namespace, function(e) {
                    s.has(e.target).length && (this.$heroContent.attr("aria-live", "polite"), o && this.$hero.slick("slickPause"))
                }.bind(this)).on("focusout" + this.namespace, function(e) {
                    s.has(e.relatedTarget).length || (this.$heroContent.removeAttr("aria-live"), o && !this.$heroPause.hasClass(t.isPaused) && this.$hero.slick("slickPlay"))
                }.bind(this)).on("keyup", this._keyboardNavigation.bind(this))
            },
            _arrowsInit: function(t, i) {
                var n = i.slideCount,
                    a = i.$slider,
                    s = $(e.heroControlsArrow);
                s.length && n > 1 ? s.on("click" + this.namespace, function(e) {
                    e.preventDefault();
                    var t = $(e.currentTarget).find("button").data("control");
                    "previous" === t ? a.slick("slickPrev") : "next" === t && a.slick("slickNext"), this._scrollTop()
                }.bind(this)) : s.remove()
            },
            _scrollTop: function() {
                var e = $(document).scrollTop(),
                    t = this.$hero.offset().top;
                e > t && $("html").add("body").animate({
                    scrollTop: t
                }, 250)
            },
            _keyboardNavigation: function(e) {
                37 === e.keyCode && this.$hero.slick("slickPrev"), 39 === e.keyCode && this.$hero.slick("slickNext")
            },
            goToSlide: function(e) {
                this.$hero.slick("slickGoTo", e)
            },
            pause: function() {
                this.$hero.slick("slickPause")
            },
            play: function() {
                this.$hero.slick("slickPlay")
            },
            destroy: function() {
                this.$hero.off(this.namespace), this.$heroContent.off(this.namespace), this.$heroPause.off(this.namespace), $(e.heroWrapper).off(this.namespace), $(e.heroControlsArrow).off(this.namespace), $(e.heroAdapt).off(this.namespace), this.$hero.slick("unslick")
            }
        }), i
    }(), window.Modals = function() {
        var e = function(e, t, i) {
            var n = {
                close: ".js-modal-close",
                open: ".js-modal-open-" + t,
                openClass: "modal--is-active"
            };
            if (this.$modal = $("#" + e), !this.$modal.length) return !1;
            this.nodes = {
                $body: $("body")
            }, this.config = $.extend(n, i), this.modalIsOpen = !1, this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal, this.init()
        };
        return e.prototype.init = function() {
            $(this.config.open).attr("aria-expanded", "false"), $(this.config.open).on("click", $.proxy(this.open, this)), this.$modal.find(this.config.close).on("click", $.proxy(this.close, this))
        }, e.prototype.open = function(e) {
            var t = !1;
            if (!this.modalIsOpen) {
                if (e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.modalIsOpen && !t) return this.close();
                this.$modal.prepareTransition().addClass(this.config.openClass), this.nodes.$body.addClass(this.config.openClass), this.modalIsOpen = !0, slate.a11y.trapFocus({
                    $container: this.$modal,
                    namespace: "modal_focus",
                    $elementToFocus: this.$focusOnOpen
                }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents()
            }
        }, e.prototype.close = function() {
            this.modalIsOpen && ($(document.activeElement).trigger("blur"), this.$modal.prepareTransition().removeClass(this.config.openClass), this.nodes.$body.removeClass(this.config.openClass), this.modalIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$modal,
                namespace: "modal_focus"
            }), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(), this.unbindEvents())
        }, e.prototype.bindEvents = function() {
            this.nodes.$body.on("keyup.modal", $.proxy(function(e) {
                27 === e.keyCode && this.close()
            }, this))
        }, e.prototype.unbindEvents = function() {
            this.nodes.$body.off(".modal")
        }, e
    }(), window.Meganav = function() {
        var e = function(e) {
            this.cache = {
                $document: $(document),
                $page: $(".page-element")
            };
            var t = {
                $meganavs: $(".meganav"),
                $megaNav: $(".meganav__nav"),
                $meganavToggle: $(".meganav-toggle"),
                $meganavDropdownContainers: $(".site-nav__dropdown-container"),
                $meganavToggleThirdLevel: $(".meganav__link-toggle"),
                $meganavLinkSecondLevel: $(".meganav__link--second-level"),
                $meganavLinkThirdLevel: $(".meganav__link--third-level"),
                $meganavDropdownThirdLevel: $(".site-nav__dropdown--third-level"),
                isOpen: !1,
                preventDuplicates: !1,
                closeOnPageClick: !1,
                closeThirdLevelOnBlur: !1,
                activeClass: "meganav--active",
                drawerClass: "meganav--drawer",
                meganavDropdown: ".site-nav__dropdown",
                meganavLinkClass: "meganav__link",
                drawerToggleClass: "drawer__nav-toggle-btn",
                drawerNavItem: ".drawer__nav-item",
                navCollectionClass: "meganav__nav--collection",
                secondLevelClass: "meganav__link--second-level",
                thirdLevelClass: "meganav__link-toggle",
                thirdLevelContainerClass: "site-nav__dropdown--third-level",
                noAnimationClass: "meganav--no-animation"
            };
            this.config = $.extend(t, e), this.init()
        };
        return e.prototype.init = function() {
            this.config.$meganavToggle.on("click", $.proxy(this.requestMeganav, this)), this.config.closeThirdLevelOnBlur && this.config.$meganavLinkThirdLevel.on("blur", $.proxy(this.closeThirdLevelMenu, this))
        }, e.prototype.requestMeganav = function(e) {
            var t;
            e && e.preventDefault(), e && e.stopPropagation && e.stopPropagation();
            var i = $(e.currentTarget),
                n = this.config.isOpen,
                a = i.hasClass(this.config.thirdLevelClass);
            if (t = i.hasClass(this.config.drawerToggleClass) ? i.closest(this.config.drawerNavItem).children("." + this.config.drawerClass) : i.siblings(this.config.meganavDropdown), i.hasClass(this.config.activeClass) && i.is("a")) window.location = i.attr("href");
            else {
                if (!a && this.config.preventDuplicates && this.close(), t.hasClass(this.config.drawerClass)) {
                    var s = "true" === i.attr("aria-expanded");
                    i.toggleClass(this.config.activeClass).attr("aria-expanded", !s), t.stop().slideToggle(200)
                } else i.addClass(this.config.activeClass).attr("aria-expanded", "true"), this.open(i, t, n);
                this.bindEvents(), this.config.isOpen = !0;
                var o = i.next();
                o.find(this.config.$megaNav).hasClass(this.config.navCollectionClass) && this.updateThirdLevelContainerWidth(i, o)
            }
        }, e.prototype.updateThirdLevelContainerWidth = function(e, t) {
            var i = t.find(this.config.$meganavDropdownThirdLevel);
            i.length && $.each(i, function(e, t) {
                var i = $(t),
                    n = i.find("li:last-child");
                this.updateContainerWidth(i, n)
            }.bind(this))
        }, e.prototype.updateContainerWidth = function(e, t) {
            var i = e[0].getBoundingClientRect(),
                n = t[0].getBoundingClientRect();
            if (!(n.left < i.right)) {
                var a = i.width,
                    s = (n.left + a - i.left) / a,
                    o = 20 * s;
                e.width(o + "%").find("li").css("width", 100 / s + "%")
            }
        }, e.prototype.open = function(e, t, i) {
            var n = e.hasClass(this.config.thirdLevelClass);
            t.addClass(this.config.activeClass), n && this.toggleSubNav(e, t), i && t.addClass(this.config.noAnimationClass)
        }, e.prototype.toggleSubNav = function(e) {
            this.removeMenuActiveState(), e.addClass(this.config.activeClass).attr("aria-expanded", "true").siblings(this.config.$meganavDropdownThirdLevel).addClass(this.config.activeClass), e.parent().addClass(this.config.activeClass)
        }, e.prototype.close = function(e, t) {
            this.config.preventDuplicates ? (this.config.$meganavs.removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")), this.config.$meganavToggle.removeClass(this.config.activeClass).attr("aria-expanded", "false"), this.config.$meganavDropdownContainers.removeClass(this.config.activeClass)) : ($("#" + t.attr("aria-controls")).removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")), t.removeClass(this.config.activeClass).attr("aria-expanded", "false"));
            this.unbindEvents(), this.config.isOpen = !1
        }, e.prototype.closeThirdLevelMenu = function(e) {
            $(e.currentTarget).parent().is(":last-child") && this.config.$meganavLinkSecondLevel.one("focus.meganav", $.proxy(function() {
                this.removeMenuActiveState()
            }, this))
        }, e.prototype.removeMenuActiveState = function() {
            var e = [this.config.activeClass, this.config.noAnimationClass];
            this.config.$meganavToggleThirdLevel.removeClass(e.join(" ")).attr("aria-expanded", "false"), this.config.$meganavDropdownThirdLevel.removeClass(e.join(" ")), this.config.$meganavDropdownContainers.removeClass(this.config.activeClass)
        }, e.prototype.bindEvents = function() {
            this.config.closeOnPageClick && (this.cache.$page.on("click.meganav", $.proxy(this.close, this)), this.config.$meganavs.on("click.meganav", function(e) {
                var t = $(e.currentTarget).hasClass(this.config.activeClass) && $(e.currentTarget).hasClass(this.config.thirdLevelContainerClass),
                    i = $(e.target).hasClass(this.config.meganavLinkClass) && $(e.target).hasClass(this.config.secondLevelClass);
                t || i || this.removeMenuActiveState(), e.stopImmediatePropagation()
            }.bind(this)), this.cache.$document.on("keyup.meganav", $.proxy(function(e) {
                27 === e.keyCode && (this.config.$meganavToggle.filter("." + this.config.activeClass).focus(), this.close())
            }, this)))
        }, e.prototype.unbindEvents = function() {
            this.config.closeOnPageClick && (this.cache.$page.off(".meganav"), this.config.$meganavs.off(".meganav"), this.cache.$document.off(".meganav"), this.config.$meganavLinkSecondLevel.off(".meganav"), this.config.$meganavLinkThirdLevel.off(".meganav"))
        }, e
    }(), window.QtySelector = function() {
        var e = function(e) {
            this.cache = {
                $body: $("body"),
                $subtotal: $("#CartSubtotal"),
                $discountTotal: $("#cartDiscountTotal"),
                $cartTable: $(".cart-table"),
                $cartTemplate: $("#CartProducts"),
                $cartFooter: $("#CartFooter"),
                $cartFooterTemplate: $("#CartFooterTemplate")
            }, this.settings = {
                loadingClass: "js-qty--is-loading",
                isCartTemplate: this.cache.$body.hasClass("template-cart"),
                minQty: this.cache.$body.hasClass("template-cart") ? 0 : 1
            }, this.$el = e, this.qtyUpdateTimeout, this.createInputs(), this.bindEvents()
        };
        return e.prototype.createInputs = function() {
            var e = this.$el,
                t = {
                    value: e.val(),
                    key: e.attr("id"),
                    name: e.attr("name"),
                    line: e.attr("data-line")
                },
                i = $("#QuantityTemplate").html(),
                n = Handlebars.compile(i);
            this.$wrapper = $(n(t)).insertBefore(e), e.remove()
        }, e.prototype.validateAvailability = function(e, t) {
  function getLanguage() {
    var language = ""; // Default language
    var languageRegex = /\/("")\//; // Regex to match language code in URL
    
    var match = window.location.pathname.match(languageRegex);
    if (match && match[1]) {
        language = match[1]; // Extract language code from URL
    }
    
    return language;
}

         
          var language = getLanguage();
            var i = theme.cartObject.items[e - 1],
                n = i.handle,
                a = i.id,
                s = {
                    type: "GET",
                    url: language + "/products/" + n + ".js",
                    dataType: "json",
                    success: $.proxy(function(i) {
                        this.validateAvailabilityCallback(e, t, a, i)
                    }, this)
                };
            $.ajax(s)
        }, e.prototype.validateAvailabilityCallback = function(e, t, i, n) {
            for (var a = !0, s = 0; s < n.variants.length; s++) {
                var o = n.variants[s];
                if (o.id === i) break
            }
            null !== o.inventory_management && "deny" === o.inventory_policy && o.inventory_quantity < t && (theme.Notify.open("error", theme.strings.noStockAvailable, !0), this.$wrapper.find(".js-qty__input").val(o.inventory_quantity), a = !1, this.$wrapper.removeClass(this.settings.loadingClass)), a && this.updateItemQuantity(e, t)
        }, e.prototype.validateQty = function(e) {
            return (parseFloat(e) !== parseInt(e, 10) || isNaN(e)) && (e = 1), parseInt(e, 10)
        }, e.prototype.adjustQty = function(e) {
            var t = $(e.currentTarget),
                i = t.siblings(".js-qty__input"),
                n = this.validateQty(i.val()),
                a = i.attr("data-line");
            t.hasClass("js-qty__adjust--minus") ? (n -= 1) <= this.settings.minQty && (n = this.settings.minQty) : n += 1, this.settings.isCartTemplate ? (t.parent().addClass(this.settings.loadingClass), this.updateCartItemPrice(a, n)) : i.val(n)
        }, e.prototype.bindEvents = function() {
            this.$wrapper.find(".js-qty__adjust").on("click", $.proxy(this.adjustQty, this)), this.$wrapper.on("click", ".js-qty__input", function() {
                this.setSelectionRange(0, this.value.length)
            }), this.settings.isCartTemplate && this.$wrapper.on("change", ".js-qty__input", $.proxy(function(e) {
                var t = $(e.currentTarget),
                    i = t.attr("data-line"),
                    n = this.validateQty(t.val());
                t.parent().addClass(this.settings.loadingClass), this.updateCartItemPrice(i, n)
            }, this))
        }, e.prototype.updateCartItemPrice = function(e, t) {
            clearTimeout(this.qtyUpdateTimeout), this.qtyUpdateTimeout = setTimeout($.proxy(function() {
                this.validateAvailability(e, t)
            }, this), 200)
        }, e.prototype.updateItemQuantity = function(e, t) {
            var i = {
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + t + "&line=" + e,
                dataType: "json",
                success: $.proxy(function(e) {
                    this.updateCartItemCallback(e)
                }, this)
            };
            $.ajax(i)
        }, e.prototype.updateCartItemCallback = function(t) {
            if (0 !== t.item_count)
                if ($("#show_price_booster").length) location.reload();
                else {
                    theme.cartObject = t;
                    var i, n, a = [],
                        s = {},
                        o = $("#CartProductTemplate").html(),
                        r = Handlebars.compile(o);
                    $.each(t.items, function(e, t) {
                        if (n = null === t.image ? "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif" : t.image.replace(/(\.[^.]*)$/, "_240x240$1").replace("http:", ""), null !== t.properties && $.each(t.properties, function(e, i) {
                                "_" !== e.charAt(0) && i || delete t.properties[e]
                            }), 0 !== t.line_level_discount_allocations.length)
                            for (var i in t.line_level_discount_allocations) {
                                var o = t.line_level_discount_allocations[i].amount;
                                t.line_level_discount_allocations[i].formattedAmount = theme.Currency.formatMoney(o, theme.moneyFormat)
                            }
                        s = {
                            key: t.key,
                            line: e + 1,
                            url: t.url,
                            img: n,
                            name: t.product_title,
                            variation: t.variant_title,
                            properties: t.properties,
                            itemQty: t.quantity,
                            price: theme.Currency.formatMoney(t.price, theme.moneyFormat),
                            vendor: t.vendor,
                            linePrice: theme.Currency.formatMoney(t.final_line_price, theme.moneyFormat),
                            originalLinePrice: theme.Currency.formatMoney(t.original_line_price, theme.moneyFormat),
                            discounts: t.line_level_discount_allocations,
                            discountsApplied: 0 !== t.line_level_discount_allocations.length
                        }, a.push(s)
                    }), i = {
                        items: a
                    }, this.cache.$cartTemplate.empty().append(r(i)), this.updateCartFooter(t), this.cache.$cartTable.find('input[type="number"]').each(function(t, i) {
                        new e($(i))
                    }), slate.a11y.pageLinkFocus(this.cache.$cartTable)
                }
            else location.reload()
        }, e.prototype.updateCartFooter = function(e) {
            if (0 !== e.cart_level_discount_applications.length)
                for (var t in e.cart_level_discount_applications) {
                    var i = e.cart_level_discount_applications[t].total_allocated_amount;
                    e.cart_level_discount_applications[t].formattedAmount = theme.Currency.formatMoney(i, theme.moneyFormat)
                }
            var n = this.cache.$cartFooterTemplate.html(),
                a = Handlebars.compile(n),
                s = {
                    totalPrice: theme.Currency.formatMoney(e.total_price, theme.moneyFormat),
                    cartDiscounts: e.cart_level_discount_applications,
                    cartDiscountsApplied: 0 !== e.cart_level_discount_applications.length
                };
            this.cache.$cartFooter.empty().append(a(s))
        }, e
    }(), window.AjaxCart = function() {
        var e = function(e) {
            this.cache = {
                $cartIconIndicator: $(".site-header__cart-indicator")
            }, this.$form = e, this.eventListeners()
        };
        return e.prototype.eventListeners = function() {
            this.$form.length && this.$form.on("submit", $.proxy(this.addItemFromForm, this))
        }, e.prototype.addItemFromForm = function(e) {
            e.preventDefault();
            var t = {
                type: "POST",
                url: "/cart/add.js",
                data: this.$form.serialize(),
                dataType: "json",
                success: $.proxy(function(e) {
                    this.success(e)
                }, this),
                error: $.proxy(function(e, t) {
                    this.error(e, t)
                }, this)
            };
            $.ajax(t)
        }, e.prototype.success = function() {
            theme.Notify.open("success", !1, !0), this.cache.$cartIconIndicator.removeClass("hide")
        }, e.prototype.error = function(e) {
            var t = JSON.parse(e.responseText);
            t.message && theme.Notify.open("error", t.description, !0)
        }, e
    }(), window.Notify = function() {
        var e = function() {
            this.cache = {
                $scrollParent: $("html").add("body"),
                $notificationSuccess: $("#NotificationSuccess"),
                $notificationSuccessLink: $("#NotificationSuccess").find("a"),
                $notificationError: $("#NotificationError"),
                $notificationPromo: $("#NotificationPromo"),
                $notificationClose: $(".notification__close"),
                $notificationErrorMessage: $(".notification__message--error")
            }, this.settings = {
                notifyActiveClass: "notification--active",
                closeTimer: 5e3,
                promoKeyName: "promo-" + this.cache.$notificationPromo.data("text")
            }, this.notifyTimer, this.$lastFocusedElement = null, this.isLocalStorageSupported = function() {
                if (window.self !== window.top) return !1;
                try {
                    var e = window.sessionStorage;
                    return e.setItem("test", "1"), e.removeItem("test"), !0
                } catch (e) {
                    return !1
                }
            }(), this.cache.$notificationClose.on("click", this.close.bind(this)), this.showPromo(), this.adaptNotification()
        };
        return e.prototype.open = function(e, t, i) {
            this.close(), "success" === e ? (this.cache.$notificationSuccess.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass), this.$lastFocusedElement = $(document.activeElement), this.cache.$notificationSuccess.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", $.proxy(function() {
                slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink)
            }, this)), this.cache.$scrollParent.hasClass("no-csstransitions") && slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink)) : (this.cache.$notificationErrorMessage.html(t), this.cache.$notificationError.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)), i && (clearTimeout(this.notifyTimer), this.notifyTimer = setTimeout(this.close.bind(this), this.settings.closeTimer))
        }, e.prototype.close = function(e) {
            e && "NotificationPromoClose" === $(e.currentTarget).attr("id") && this.isLocalStorageSupported && localStorage.setItem(this.settings.promoKeyName, "hidden"), this.$lastFocusedElement && this.cache.$notificationSuccessLink.is(":focus") && slate.a11y.pageLinkFocus(this.$lastFocusedElement), this.cache.$notificationSuccess.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.cache.$notificationError.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.cache.$notificationPromo.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass), this.$lastFocusedElement = null
        }, e.prototype.showPromo = function(e) {
            e && this.initCache(), this.isLocalStorageSupported && "hidden" === localStorage[this.settings.promoKeyName] || this.cache.$notificationPromo.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)
        }, e.prototype.adaptNotification = function() {
            var e = $(".hero").data("adapt-height"),
                t = $("#NotificationPromo"),
                i = t.children(".notification__inner");
            t.length && (t.toggleClass("notification-adapt page-width", !0 === e), i.toggleClass("page-width", !1 === e))
        }, e
    }(), theme.Maps = function() {
        var e = {
                zoom: 14,
                styles: [{
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{
                        color: "#cacaca"
                    }, {
                        lightness: 17
                    }]
                }, {
                    featureType: "landscape",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e1e1e1"
                    }, {
                        lightness: 20
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#ffffff"
                    }, {
                        lightness: 17
                    }]
                }, {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#ffffff"
                    }, {
                        lightness: 29
                    }, {
                        weight: .2
                    }]
                }, {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff"
                    }, {
                        lightness: 18
                    }]
                }, {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [{
                        color: "#ffffff"
                    }, {
                        lightness: 16
                    }]
                }, {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{
                        color: "#e1e1e1"
                    }, {
                        lightness: 21
                    }]
                }, {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{
                        color: "#bbbbbb"
                    }, {
                        lightness: 21
                    }]
                }, {
                    elementType: "labels.text.stroke",
                    stylers: [{
                        visibility: "on"
                    }, {
                        color: "#ffffff"
                    }, {
                        lightness: 16
                    }]
                }, {
                    elementType: "labels.text.fill",
                    stylers: [{
                        saturation: 36
                    }, {
                        color: "#333333"
                    }, {
                        lightness: 40
                    }]
                }, {
                    elementType: "labels.icon",
                    stylers: [{
                        visibility: "off"
                    }]
                }, {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [{
                        color: "#f2f2f2"
                    }, {
                        lightness: 19
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry.fill",
                    stylers: [{
                        color: "#fefefe"
                    }, {
                        lightness: 20
                    }]
                }, {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [{
                        color: "#fefefe"
                    }, {
                        lightness: 17
                    }, {
                        weight: 1.2
                    }]
                }]
            },
            t = null,
            i = [];

        function n(e) {
            theme.$currentMapContainer = this.$container = $(e);
            var n = this.$container.data("api-key");
            if ("string" == typeof n && "" !== n)
                if ("loaded" === t) {
                    var a = this;
                    0 === $('script[src*="' + n + '&"]').length ? $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n).then(function() {
                        t = "loaded", a.createMap()
                    }) : this.createMap()
                } else i.push(this), "loading" !== t && (t = "loading", void 0 === window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n).then(function() {
                    t = "loaded", $.each(i, function(e, t) {
                        t.createMap()
                    })
                }))
        }
        return n.prototype = _.assignIn({}, n.prototype, {
            createMap: function() {
                var t = this.$container.find(".map-section__container");
                return function(e) {
                    var t = $.Deferred(),
                        i = new google.maps.Geocoder,
                        n = e.data("address-setting");
                    return i.geocode({
                        address: n
                    }, function(e, i) {
                        i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e)
                    }), t
                }(t).then(function(i) {
                    var n = {
                            zoom: e.zoom,
                            styles: e.styles,
                            center: i[0].geometry.location,
                            draggable: !1,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            disableDoubleClickZoom: !0,
                            disableDefaultUI: !0
                        },
                        a = this.map = new google.maps.Map(t[0], n),
                        s = this.center = a.getCenter(),
                        o = t.data("enable-pin"),
                        r = {
                            path: "M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z",
                            fillColor: t.data("marker-color"),
                            fillOpacity: .9,
                            scale: .2,
                            strokeWeight: 0
                        };
                    new google.maps.Marker({
                        map: a,
                        position: s,
                        icon: r,
                        visible: o
                    });
                    google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                        google.maps.event.trigger(a, "resize"), a.setCenter(s)
                    }))
                }.bind(this)).fail(function() {
                    var e;
                    switch (status) {
                        case "ZERO_RESULTS":
                            e = theme.strings.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            e = theme.strings.addressQueryLimit;
                            break;
                        default:
                            e = theme.strings.addressError
                    }
                    if (Shopify.designMode) {
                        var i = t.parents(".map-section");
                        i.addClass("page-width map-section--load-error"), i.find(".map-section__content-wrapper").remove(), i.find(".map-section__wrapper").html('<div class="errors text-center" style="width: 100%;">' + e + "</div>")
                    }
                })
            },
            onUnload: function() {
                void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize")
            }
        }), n
    }(), theme.stickyHeader = function() {
        var e = {
                searchCartWrapper: "#SiteNavSearchCart",
                stickyNavSearchCart: "#StickyNavSearchCart",
                stickyNavWrapper: "#StickNavWrapper",
                stickyBar: "#StickyBar"
            },
            t = {
                lastScroll: 0,
                navClass: "sticky--active",
                openTransitionClass: "sticky--open",
                closeTransitionClass: "sticky--close"
            },
            i = {};

        function n() {
            var n = i.$window.scrollTop(),
                a = $(e.stickyNavWrapper),
                s = a.offset().top + a.height() + 10;
            n < t.lastScroll && (s = a.offset().top), n > s ? function() {
                if (t.isActive) return;
                t.isActive = !0, i.$stickyBar.addClass(t.navClass), setTimeout(function() {
                    i.$stickyBar.addClass(t.openTransitionClass)
                }, 0)
            }() : function() {
                if (!t.isActive) return;
                i.$stickyBar.removeClass(t.openTransitionClass).removeClass(t.navClass), t.isActive = !1
            }(), t.lastScroll = n
        }
        return {
            init: function() {
                i = {
                    $window: $(window),
                    $siteNavSearchCart: $(e.searchCartWrapper),
                    $stickyBar: $(e.stickyBar)
                }, t.isActive = !1, i.$siteNavSearchCart.contents().length && i.$siteNavSearchCart.contents().clone().appendTo($(e.stickyNavSearchCart)), i.$window.on("scroll.stickynav", $.throttle(15, n))
            },
            unload: function() {
                $(window).off(".stickynav")
            }
        }
    }(), theme.headerNav = function() {
        var e = {
                siteNav: "#SiteNav",
                siteNavCompressed: "#SiteNavCompressed",
                siteNavParent: "#SiteNavParent",
                siteNavItem: ".site-nav__item",
                stickyNavWrapper: "#StickNavWrapper",
                stickyNav: "#StickyNav"
            },
            t = {
                lastScroll: 0,
                isActive: !1,
                navClass: "sticky--active",
                openTransitionClass: "sticky--open",
                closeTransitionClass: "sticky--close",
                searchInputClass: "site-header__search-input",
                searchSubmitClass: "site-header__search-submit",
                searchInnerActiveClass: "search-header__search-inner--active"
            };

        function i() {
            var t = 0,
                i = $(e.siteNavParent).width();
            $(e.stickyNavWrapper).height($(e.stickyNav).height()), $(e.siteNav).removeClass("hide"), $(e.siteNavItem).each(function(e, i) {
                t += $(i).width()
            }), t > i ? ($(e.siteNav).addClass("hide"), $(e.siteNavCompressed).removeClass("hide")) : ($(e.siteNav).removeClass("hide"), $(e.siteNavCompressed).addClass("hide"))
        }
        return {
            init: function() {
                i(), new window.Meganav({
                    $meganavs: $(".site-nav__dropdown"),
                    $meganavToggle: $(".site-nav__link-toggle"),
                    preventDuplicates: !0,
                    closeOnPageClick: !0,
                    closeThirdLevelOnBlur: !0
                }), new window.Meganav({
                    $meganavs: $(".meganav--index"),
                    $meganavToggle: $(".index__meganav-toggle")
                }), new window.Meganav({
                    $meganavs: $(".meganav--drawer"),
                    $meganavToggle: $(".drawer__meganav-toggle")
                }), $(".site-header__search").each(function(e, i) {
                    var n = $(i),
                        a = n.find("." + t.searchInputClass),
                        s = n.find("." + t.searchSubmitClass);
                    a.add(s).on("focus blur", function() {
                        n.toggleClass("active-form")
                    }), s.on("mousedown", function() {
                        n.hasClass("active-form") && n.submit()
                    })
                }), $(window).on("resize.headernav", $.debounce(250, i))
            },
            unload: function() {
                $(window).off(".stickynav")
            }
        }
    }(), theme.customerTemplates = function() {
        function e() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide")
        }
        return {
            init: function() {
                var t;
                "#recover" === window.location.hash && e(), $("#RecoverPassword").on("click", function(t) {
                    t.preventDefault(), e()
                }), $("#HideRecoverPasswordLink").on("click", function(t) {
                    t.preventDefault(), e()
                }), $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"), (t = $("#AddressNewForm")).length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                    hideElement: "AddressProvinceContainerNew"
                }), $(".address-country-option").each(function() {
                    var e = $(this).data("form-id"),
                        t = "AddressCountry_" + e,
                        i = "AddressProvince_" + e,
                        n = "AddressProvinceContainer_" + e;
                    new Shopify.CountryProvinceSelector(t, i, {
                        hideElement: n
                    })
                }), $(".address-new-toggle").on("click", function() {
                    t.toggleClass("hide")
                }), $(".address-edit-toggle").on("click", function() {
                    var e = $(this).data("form-id");
                    $("#EditAddress_" + e).toggleClass("hide")
                }), $(".address-delete").on("click", function() {
                    var e = $(this),
                        t = e.data("form-id"),
                        i = e.data("confirm-message");
                    confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, {
                        parameters: {
                            _method: "delete"
                        }
                    })
                }))
            }
        }
    }(), theme.HeaderSection = function() {
        function e() {
            var e;
            theme.stickyHeader.init(), theme.headerNav.init(), theme.Notify = new window.Notify, theme.NavDrawer = new window.Drawers("NavDrawer", "left"), e = $(".drawer__search-input"), $(".drawer__search-submit").on("click", function(t) {
                0 === e.val().length && (t.preventDefault(), e.focus())
            })
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            onSelect: function() {
                theme.Notify.adaptNotification()
            },
            onUnload: function() {
                theme.stickyHeader.unload(), theme.headerNav.unload()
            }
        }), e
    }(), theme.Filters = function() {
        var e = {
            filterSelection: "#SortTags",
            sortSelection: "#SortBy"
        };

        function t() {
            this.$filterSelect = $(e.filterSelection), this.$sortSelect = $(e.sortSelection), this.$filterSelect.on("change", this._onFilterChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this))
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _onFilterChange: function() {
                delete Shopify.queryParams.page, $.isEmptyObject(Shopify.queryParams) ? location.href = this.$filterSelect.val() : location.href = this.$filterSelect.val() + "?" + $.param(Shopify.queryParams)
            },
            _onSortChange: function() {
                Shopify.queryParams.sort_by = this.$sortSelect.val(), location.search = $.param(Shopify.queryParams)
            },
            onUnload: function() {
                this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange)
            }
        }), t
    }(), theme.Product = function() {
        var e = {
            verySmallBreakPoint: 370,
            smallBreakpoint: 750,
            productThumbIndex: 0,
            productThumbMax: 0,
            ajaxCart: !1,
            stockSetting: !1
        };

        function t(t) {
            var i = this.$container = $(t),
                n = i.attr("data-section-id");
            this.selectors = {
                originalSelectorId: "#ProductSelect-" + n,
                modal: "ProductModal",
                productZoomImage: "#ProductZoomImg",
                addToCart: "#AddToCart-" + n,
                productPrice: "#ProductPrice-" + n,
                comparePrice: "#ComparePrice-" + n,
                addToCartText: "#AddToCartText-" + n,
                SKU: ".variant-sku",
                productImageContainers: ".product__photo-container-" + n,
                productImageWrappers: ".product__photo-wrapper-" + n,
                productThumbContainers: ".product-single__thumbnail-item-" + n,
                productThumbsWrapper: ".product-single__thumbnails-" + n,
                productThumbs: ".product-single__thumbnail-" + n,
                saleTag: "#ProductSaleTag-" + n,
                productStock: "#ProductStock-" + n,
                singleOptionSelector: ".single-option-selector-" + n,
                shopifyPaymentButton: ".shopify-payment-button"
            }, this.settings = $.extend({}, e, {
                sectionId: n,
                ajaxCart: i.data("ajax"),
                stockSetting: i.data("stock"),
                enableHistoryState: i.data("enable-history-state") || !1,
                namespace: ".product-" + n
            }), $("#ProductJson-" + n).html() && (this.productSingleObject = JSON.parse($("#ProductJson-" + n).html()), this.addVariantInfo(), this.init())
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            init: function() {
                this._stringOverrides(), this._initVariants(), this._productZoomImage(), this._productThumbSwitch(), this._productThumbnailSlider(), this._initQtySelector(), this.settings.ajaxCart && (theme.AjaxCart = new window.AjaxCart($("#AddToCartForm-" + this.settings.sectionId)))
            },
            _stringOverrides: function() {
                window.productStrings = window.productStrings || {}, $.extend(theme.strings, window.productStrings)
            },
            addVariantInfo: function() {
                if (this.productSingleObject && this.settings.stockSetting)
                    for (var e = JSON.parse($("#VariantJson-" + this.settings.sectionId).html()), t = 0; t < e.length; t++) $.extend(this.productSingleObject.variants[t], e[t])
            },
            _initVariants: function() {
                var e = {
                    $container: this.$container,
                    enableHistoryState: this.settings.enableHistoryState,
                    product: this.productSingleObject,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId
                };
                this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCartBtn.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this))
            },
            _updateStock: function(e) {
                if (this.settings.stockSetting) {
                    var t = $(this.selectors.productStock);
                    e && e.inventory_management ? e.inventory_quantity < 10 && e.inventory_quantity > 0 ? t.html(theme.strings.stockAvailable.replace("1", e.inventory_quantity)).removeClass("hide") : e.inventory_quantity <= 0 && e.incoming ? t.html(theme.strings.willNotShipUntil.replace("[date]", e.next_incoming_date)).removeClass("hide") : t.addClass("hide") : t.addClass("hide")
                }
            },
            _updateIncomingInfo: function(e) {
                if (this.settings.stockSetting) {
                    var t = $(this.selectors.productStock);
                    e.incoming ? t.html(theme.strings.willBeInStockAfter.replace("[date]", e.next_incoming_date)).removeClass("hide") : t.addClass("hide")
                }
            },
            _updateAddToCartBtn: function(e) {
                var t = e.variant,
                    i = {
                        $addToCart: $(this.selectors.addToCart),
                        $addToCartText: $(this.selectors.addToCartText)
                    };
                t ? t.available ? (i.$addToCart.removeClass("btn--sold-out").prop("disabled", !1), i.$addToCartText.html(theme.strings.addToCart), $(this.selectors.shopifyPaymentButton, this.$container).show(), this._updateStock(t)) : (i.$addToCart.prop("disabled", !0).addClass("btn--sold-out"), i.$addToCartText.html(theme.strings.soldOut), $(this.selectors.shopifyPaymentButton, this.$container).hide(), this._updateIncomingInfo(t)) : (i.$addToCart.prop("disabled", !0).removeClass("btn--sold-out"), i.$addToCartText.html(theme.strings.unavailable), $(this.selectors.shopifyPaymentButton, this.$container).hide(), this._updateStock())
            },
            _updatePrice: function(e) {
                var t = e.variant;
                t ? ($(this.selectors.productPrice).html('<span class="money">' + theme.Currency.formatMoney(t.price, theme.moneyFormat) + "</span>"), t.compare_at_price > t.price ? ($(this.selectors.comparePrice).html('<span class="money">' + theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat) + "</span>").removeClass("hide"), $(this.selectors.saleTag).removeClass("hide")) : ($(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleTag).addClass("hide"))) : $(this.selectors.comparePrice).addClass("hide")
            },
            _updateSKU: function(e) {
                var t = e.variant;
                t && $(this.selectors.SKU).html(t.sku)
            },
            _updateImages: function(e) {
                var t = e.variant;
                if (t && t.featured_media) {
                    var i = t.featured_media.id;
                    this.switchProductImage(i), this.setActiveThumbnail(i)
                }
            },
            switchProductImage: function(e) {
                var t = $(this.selectors.productImageContainers + "[data-image-id='" + e + "']", this.$container);
                $(this.selectors.productImageContainers + ":not([data-image-id='" + e + "'])", this.$container).addClass("hide"), t.removeClass("hide")
            },
            setActiveThumbnail: function(e) {
                var t = $(this.selectors.productThumbContainers + "[data-image-id='" + e + "']", this.$container);
                $(this.selectors.productThumbContainers + ":not([data-image-id='" + e + "'])", this.$container).removeClass("is-active"), t.addClass("is-active");
                var i = $(this.selectors.productThumbsWrapper, this.$container);
                if (i.hasClass("slick-initialized")) {
                    var n = i.slick("slickCurrentSlide"),
                        a = parseInt(t.attr("data-slick-index"));
                    n !== a && i.slick("slickGoTo", a, !1)
                }
            },
            _productZoomImage: function() {
                if ($(".product-single " + this.selectors.productImageContainers).length) {
                    var e = this;
                    $(this.selectors.productImageWrappers).on("click" + this.settings.namespace, function(t) {
                        t.preventDefault(), $(e.selectors.productZoomImage).attr("src", "").attr("src", $(this).attr("href"))
                    }), this.ProductModal = new window.Modals(this.selectors.modal, "product-modal"), this.ProductModal.$modal.on("click" + this.settings.namespace, function(t) {
                        "IMG" !== t.target.nodeName && e.ProductModal.close()
                    })
                }
            },
            _productThumbSwitch: function() {
                if ($(this.selectors.productThumbs).length) {
                    var e = this;
                    $(this.selectors.productThumbs).on("click" + this.settings.namespace, function(t) {
                        t.preventDefault();
                        var i = $(this).parent().data("image-id");
                        e.setActiveThumbnail(i), e.switchProductImage(i)
                    })
                }
            },
            _productThumbnailSlider: function() {
                var e = $(this.selectors.productThumbsWrapper),
                    t = $(this.selectors.productThumbs);
                if (t.length && t.length > 2) {
                    var i, n;
                    e.on("init" + this.settings.namespace, this._productSwipeInit.bind(this));
                    var a = window.sliderArrows || !1;
                    a && (i = '<button type="button" class="slick-next"><span class="medium-up--hide">' + a.right + '</span><span class="small--hide">' + a.down + "</span></button>", n = '<button type="button" class="slick-prev"><span class="medium-up--hide">' + a.left + '</span><span class="small--hide">' + a.up + "</span></button>"), e.slick({
                        accessibility: !1,
                        arrows: !0,
                        dots: !1,
                        infinite: !1,
                        autoplay: !1,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        vertical: !0,
                        verticalSwiping: !0,
                        nextArrow: i,
                        prevArrow: n,
                        responsive: [{
                            breakpoint: this.settings.smallBreakpoint,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                                arrows: !1,
                                dots: !0,
                                vertical: !1,
                                verticalSwiping: !1
                            }
                        }, {
                            breakpoint: this.settings.verySmallBreakPoint,
                            settings: {
                                arrows: !1,
                                dots: !0,
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                vertical: !1,
                                verticalSwiping: !1
                            }
                        }]
                    }), e.slick("slickGoTo", e.find(".is-active").attr("data-slick-index"), !0)
                }
            },
            _productSwipeInit: function(e, t) {
                this.settings.productThumbIndex = t.currentSlide, this.settings.productThumbMax = t.slideCount - 1;
                var i = this;
                $(this.selectors.productImageWrappers).on("swipeleft swiperight", function(e) {
                    "swipeleft" === e.type && i._goToNextThumbnail(), "swiperight" === e.type && i._goToPrevThumbnail(), $('.product-single__thumbnail-item[data-slick-index="' + i.settings.productThumbIndex + '"]').find(".product-single__thumbnail").trigger("click")
                })
            },
            _goToNextThumbnail: function() {
                this.settings.productThumbIndex++, this.settings.productThumbIndex > this.settings.productThumbMax && (this.settings.productThumbIndex = 0), $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0)
            },
            _goToPrevThumbnail: function() {
                this.settings.productThumbIndex--, this.settings.productThumbIndex < 0 && (this.settings.productThumbIndex = this.settings.productThumbMax), $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0)
            },
            _initQtySelector: function() {
                this.$container.find(".product-form__quantity").each(function(e, t) {
                    new QtySelector($(t))
                })
            },
            onUnload: function() {
                $(this.selectors.productImageWrappers).off(this.settings.namespace), $(this.selectors.productThumbs).off(this.settings.namespace), $(this.selectors.productThumbs).slick("unslick"), this.ProductModal && this.ProductModal.$modal.off(this.settings.namespace)
            }
        }), t
    }(), theme.Slideshow = function() {
        function e() {
            this.slideshow = new theme.Hero
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            onUnload: function() {
                this.slideshow.destroy()
            },
            onSelect: function() {
                this.slideshow.pause(), theme.Notify.adaptNotification()
            },
            onDeselect: function() {
                this.slideshow.play()
            },
            onBlockSelect: function(e) {
                var t = $(".hero__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                this.slideshow.pause(), this.slideshow.goToSlide(t)
            },
            onBlockDeselect: function() {
                this.slideshow.play()
            }
        }), e
    }(), theme.Cart = function() {
        var e = "#CartSpecialInstructions",
            t = ".cart__quantity",
            i = "cart--no-cookies";

        function n(e) {
            var t = this.$container = $(e),
                i = t.attr("data-section-id");
            theme.cartObject = JSON.parse($("#CartJson-" + i).html()), this.init(t)
        }
        return n.prototype = _.assignIn({}, n.prototype, {
            init: function(e) {
                this._initQtySelector(), this._initCartNote(), this._cookiesEnabled() || e.addClass(i)
            },
            _initQtySelector: function() {
                $(t).each(function(e, t) {
                    new QtySelector($(t))
                })
            },
            _initCartNote: function() {
                if ($(e).length) {
                    var t, i, n = $(e),
                        a = n[0].offsetHeight - n[0].clientHeight;
                    n.on("keyup input", function() {
                        $(this).css("height", "auto").css("height", n[0].scrollHeight + a)
                    }), n.on("change", $.proxy(function() {
                        t = n.val(), i = {
                            type: "POST",
                            url: "/cart/update.js",
                            data: "note=" + this._attributeToString(t),
                            dataType: "json"
                        }, $.ajax(i)
                    }, this))
                }
            },
            _attributeToString: function(e) {
                return "string" != typeof e && "undefined" === (e = String(e)) && (e = ""), $.trim(e)
            },
            _cookiesEnabled: function() {
                var e = navigator.cookieEnabled;
                return e || (document.cookie = "testcookie", e = -1 !== document.cookie.indexOf("testcookie")), e
            }
        }), n
    }(), theme.Quotes = function() {
        function e(e) {
            this.$container = $(e).on("init", this._a11y.bind(this)), this.$container.slick({
                accessibility: !0,
                arrows: !1,
                dots: !0,
                draggable: !0,
                autoplay: !1
            })
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _a11y: function(e, t) {
                var i = t.$list,
                    n = this.$container.parent();
                i.removeAttr("aria-live"), n.on("focusin", function(e) {
                    n.has(e.target).length && i.attr("aria-live", "polite")
                }), n.on("focusout", function(e) {
                    n.has(e.target).length && i.removeAttr("aria-live")
                })
            },
            _goToSlide: function(e) {
                this.$container.slick("slickGoTo", e)
            },
            onUnload: function() {
                delete this.$container
            },
            onBlockSelect: function(e) {
                var t = $(".quote__slide-wrapper--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                this._goToSlide(t)
            }
        }), e
    }(), theme.Video = function() {
        var e, t, i = {
                promiseAPI: function() {
                    if (!e) {
                        var t = document.createElement("script");
                        t.src = "https://www.youtube.com/iframe_api";
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(t, i), e = $.Deferred(function(e) {
                            window.onYouTubeIframeAPIReady = e.resolve, setTimeout(function() {
                                e.reject("Request for YouTube API timed out after 30 seconds.")
                            }, 3e4)
                        })
                    }
                    return e
                },
                promisePlayer: function(e, t) {
                    return this.promiseAPI().then(function() {
                        return $.Deferred(function(i) {
                            void 0 === window.YT && i.reject("We're sorry, something went wrong. The YouTube API has not loaded correctly.");
                            var n = new YT.Player(e, t);
                            n.addEventListener("onReady", function() {
                                i.resolve(n)
                            }), setTimeout(function() {
                                i.reject("Request for YouTube player has timed out after 30 seconds.")
                            }, 3e4)
                        })
                    })
                }
            },
            n = {
                promiseAPI: function() {
                    return t || (t = $.Deferred(function(e) {
                        var t = document.createElement("script");
                        t.src = "https://player.vimeo.com/api/player.js", t.onload = t.onreadystatechange = function() {
                            this.readyState && "complete" !== this.readyState || e.resolve()
                        };
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(t, i), setTimeout(function() {
                            e.reject("Request for Vimeo API timed out after 30 seconds.")
                        }, 3e4)
                    })), t
                },
                promisePlayer: function(e, t) {
                    return this.promiseAPI().then(function() {
                        return $.Deferred(function(i) {
                            void 0 === window.Vimeo && i.reject("We're sorry, something went wrong. The Vimeo API has not loaded correctly.");
                            var n = new window.Vimeo.Player(e, t);
                            setTimeout(function() {
                                i.reject("Request for Vimeo player has timed out after 30 seconds.")
                            }, 3e4), n.ready().then(function() {
                                i.resolve(n)
                            })
                        })
                    })
                }
            },
            a = ".video-section__load-player-button",
            s = ".video-section__player-close",
            o = ".video-section__player",
            r = ".video-section__cover",
            c = ".video-section__error",
            l = ".video-section__body-overlay",
            h = "body",
            d = "video-section--loaded",
            u = "video-section--error",
            p = "video-playing";

        function m(e) {
            this.$container = $(e);
            var t = this.$container.attr("data-section-id");
            this.namespace = "." + t, this.onLoad()
        }
        return m.prototype = _.assignIn({}, m.prototype, {
            onLoad: function() {
                this.$container.on("click", a, this._loadPlayer.bind(this)).on("click", s, this._closePlayer.bind(this)).on("click", l, this._closePlayer.bind(this))
            },
            _loadPlayer: function() {
                var e, t = this.$container,
                    i = $(o, t),
                    n = this.$container.attr("data-video-type");
                return "youtube" === n ? e = this._loadYoutubePlayer(i[0]) : "vimeo" === n && (e = this._loadVimeoPlayer(i[0])), e.then(this._onPlayerLoadReady.bind(this)).fail(this._onPlayerLoadError.bind(this))
            },
            _loadYoutubePlayer: function(e) {
                return i.promisePlayer(e, {
                    videoId: this.$container.attr("data-video-id"),
                    ratio: 16 / 9,
                    playerVars: {
                        modestbranding: 1,
                        autoplay: 1,
                        showinfo: 0,
                        rel: 0
                    }
                }).then(function(e) {
                    this.player = e
                }.bind(this))
            },
            _loadVimeoPlayer: function(e) {
                return n.promisePlayer(e, {
                    id: this.$container.attr("data-video-id")
                }).then(function(e) {
                    this.player = e, this.player.play()
                }.bind(this))
            },
            _onPlayerLoadReady: function() {
                $(s, this.$container).show().focus(), $(r, this.$container).addClass(d), this.$container.addClass(d), this._setScrollPositionValues(), $(h).addClass(p), $(document).on("keyup" + this.namespace, this._closeOnEscape.bind(this)), $(window).on("resize" + this.namespace, this._setScrollPositionValues.bind(this)), slate.a11y.trapFocus({
                    $container: this.$container,
                    namespace: this.namespace
                })
            },
            _onPlayerLoadError: function(e) {
                this.$container.addClass(u), $(c, this.$container).text(e)
            },
            _closeOnEscape: function(e) {
                27 === e.keyCode && (this._closePlayer(), $(a, this.$container).focus())
            },
            _onScroll: function() {
                var e = $(window).scrollTop();
                (e > this.videoTop + .25 * this.videoHeight || e + this.windowHeight < this.videoBottom - .25 * this.videoHeight) && requestAnimationFrame(this._closePlayer.bind(this))
            },
            _setScrollPositionValues: function() {
                this.videoHeight = this.$container.outerHeight(!0), this.videoTop = this.$container.offset().top, this.videoBottom = this.videoTop + this.videoHeight, this.windowHeight = $(window).innerHeight()
            },
            _closePlayer: function() {
                $(h).removeClass(p), $(r, this.$container).removeClass(d), this.$container.removeClass(d), $(s, this.$container).hide(), slate.a11y.removeTrapFocus({
                    $container: this.$container,
                    namespace: this.namespace
                }), "function" == typeof this.player.destroy ? this.player.destroy() : "function" == typeof this.player.unload && this.player.unload(), $(document).off(this.namespace), $(window).off(this.namespace)
            }
        }), m
    }(), theme.CollectionsList = function() {
        function e(e) {
            var t = this.$container = $(e);
            if (!t.is("[data-stretch-image]")) {
                var i = this.namespace = "." + t.attr("data-section-id"),
                    n = this;
                n._collectionListFix(), $(window).on("resize" + i, $.debounce(250, function() {
                    n._collectionListFix()
                }))
            }
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            onUnload: function() {
                $(window).off(this.namespace)
            },
            _collectionListFix: function() {
                var e = this.$container.find(".grid").data("number-rows"),
                    t = this.$container.find(".featured-card");
                if (!t.is("[data-stretch-image]"))
                    for (var i = 0; i < e; i++) {
                        var n = 0,
                            a = 0,
                            s = t.filter("[data-row-number='" + (i + 1) + "']"),
                            o = s.find(".featured-card__header");
                        s.each(function() {
                            var e = $(this).find(".featured-card__title"),
                                t = $(this).find(".featured-card__action"),
                                i = $(this).find(".featured-card__image-wrapper"),
                                s = e.outerHeight() + t.outerHeight() + 65,
                                o = i.outerHeight();
                            s > a && (a = s), o > n && (n = o)
                        }), o.outerHeight(a), s.height(n + a + 40)
                    }
            }
        }), e
    }(), theme.init = function() {
        theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(e) {
            slate.a11y.pageLinkFocus($(e.currentTarget.hash))
        }), $('a[href="#"]').on("click", function(e) {
            e.preventDefault()
        });
        var e = new theme.Sections;
        e.register("header", theme.HeaderSection), e.register("product", theme.Product), e.register("featured-product", theme.Product), e.register("collection-filters", theme.Filters), e.register("map", theme.Maps), e.register("slideshow", theme.Slideshow), e.register("cart", theme.Cart), e.register("quotes", theme.Quotes), e.register("video", theme.Video), e.register("collections-list", theme.CollectionsList), $(window).on("load", theme.articleImages), theme.passwordModalInit()
    }, theme.articleImages = function() {
        var e = $(".rte--indented-images");
        e.length && e.find("img").each(function(t, i) {
            var n = $(i),
                a = n.attr("style");
            a && "float: none;" !== a || n.width() >= e.width() && n.parent("p").addClass("rte__image-indent")
        })
    }, theme.passwordModalInit = function() {
        var e = $("#LoginModal");
        e.length && (theme.PasswordModal = new window.Modals("LoginModal", "login-modal", {
            focusOnOpen: "#Password"
        }), e.find(".errors").length && theme.PasswordModal.open())
    }, $(theme.init), $(document).ready(function() {
        $("select[id^='SingleOptionSelector-']").each(function() {
            1 == $("option", this).length && $(this).parent().hide()
        })
    }), $("#AddToCart-product-template").length) {
    var addToCartBtn = $("#AddToCart-product-template"),
        handler = onVisibilityChange(addToCartBtn, function() {
            isElementInViewport(addToCartBtn) ? $("#btn-addtocart-mobile").hide() : $("#btn-addtocart-mobile").show()
        });
    $(window).on("DOMContentLoaded load resize scroll", handler)
}
if (function(e) {
        e.fn.readingTime = function(t) {
            const i = e(this);
            let n, a, s, o, r, c, l, h, d;
            this.settings = e.extend({}, {
                readingTimeTarget: ".eta",
                readingTimeAsNumber: !1,
                wordCountTarget: null,
                wordsPerMinute: 270,
                round: !0,
                lang: "fr",
                lessThanAMinuteString: "",
                prependTimeString: "",
                prependWordString: "",
                remotePath: null,
                remoteTarget: null,
                success: function() {},
                error: function() {}
            }, t);
            const u = this.settings,
                p = function(t) {
                    "" !== t.text ? (o = t.text.trim().split(/\s+/g).length, n = u.wordsPerMinute / 60, r = o / n, c = Math.floor(r / 60), l = Math.round(r - 60 * c), h = `${c}:${l}`, u.round ? c > 0 ? e(u.readingTimeTarget).text(u.prependTimeString + c + (u.readingTimeAsNumber ? "" : " " + s)) : e(u.readingTimeTarget).text(u.readingTimeAsNumber ? c : u.prependTimeString + a) : e(u.readingTimeTarget).text(u.prependTimeString + h), "" !== u.wordCountTarget && void 0 !== u.wordCountTarget && e(u.wordCountTarget).text(u.prependWordString + o), d = {
                        wpm: u.wordsPerMinute,
                        words: o,
                        eta: {
                            time: h,
                            minutes: c,
                            seconds: r
                        }
                    }, u.success.call(this, d)) : u.error.call(this, {
                        error: "The element does not contain any text"
                    })
                };
            if (!this.length) return u.error.call(this, {
                error: "The element could not be found"
            }), this;
            switch (u.lang) {
                case "ar":
                    a = u.lessThanAMinuteString || "أقل من دقيقة", s = "دقيقة";
                    break;
                case "cz":
                    a = u.lessThanAMinuteString || "Méně než minutu", s = "min";
                    break;
                case "da":
                    a = u.lessThanAMinuteString || "Mindre end et minut", s = "min";
                    break;
                case "de":
                    a = u.lessThanAMinuteString || "Weniger als eine Minute", s = "min";
                    break;
                case "es":
                    a = u.lessThanAMinuteString || "Menos de un minuto", s = "min";
                    break;
                case "fr":
                    a = u.lessThanAMinuteString || "Moins d'une minute", s = "min";
                    break;
                case "hu":
                    a = u.lessThanAMinuteString || "Kevesebb mint egy perc", s = "perc";
                    break;
                case "is":
                    a = u.lessThanAMinuteString || "Minna en eina mínútu", s = "min";
                    break;
                case "it":
                    a = u.lessThanAMinuteString || "Meno di un minuto", s = "min";
                    break;
                case "nl":
                    a = u.lessThanAMinuteString || "Minder dan een minuut", s = "min";
                    break;
                case "no":
                    a = u.lessThanAMinuteString || "Mindre enn ett minutt", s = "min";
                    break;
                case "pl":
                    a = u.lessThanAMinuteString || "Mniej niż minutę", s = "min";
                    break;
                case "ru":
                    a = u.lessThanAMinuteString || "Меньше минуты", s = "мин";
                    break;
                case "sk":
                    a = u.lessThanAMinuteString || "Menej než minútu", s = "min";
                    break;
                case "sv":
                    a = u.lessThanAMinuteString || "Mindre än en minut", s = "min";
                    break;
                case "tr":
                    a = u.lessThanAMinuteString || "Bir dakikadan az", s = "dk";
                    break;
                case "uk":
                    a = u.lessThanAMinuteString || "Менше хвилини", s = "хв";
                    break;
                case "el":
                    a = u.lessThanAMinuteString || "Λιγότερο από λεπτό", s = "λεπτά";
                    break;
                default:
                    a = u.lessThanAMinuteString || "Less than a minute", s = "min"
            }
            return i.each(function(t) {
                null != u.remotePath && null != u.remoteTarget ? e.get(u.remotePath, function(t) {
                    let i = document.createElement("div");
                    i.innerHTML = t, p({
                        text: e(i).find(u.remoteTarget).text()
                    })
                }) : p({
                    text: i.text()
                })
            }), !0
        }
    }(jQuery), $(function() {
        $("article").readingTime({
            wordCountTarget: ".words"
        })
    }), $(".grid__item_blog_padding").length > 0) {
    var arrayHeight = [];
    $(".grid__item_blog_padding").each(function(e) {
        var t = $(this).outerHeight();
        arrayHeight.push(t)
    });
    var largestHeight = Math.max.apply(Math, arrayHeight);
    $(".grid__item_blog_padding").css("height", largestHeight)
}
if ($(".article-block__title").length > 0) {
    var arrayHeightSec = [];
    $(".article-block__title").each(function(e) {
        var t = $(this).outerHeight();
        arrayHeightSec.push(t)
    });
    var largestHeightSec = Math.max.apply(Math, arrayHeightSec);
    $(".article-block__title").css("height", largestHeightSec)
}
$(document).ready(function() {
    thumbnails = $('img[src*="/products/"]').not(":first"), thumbnails.length && thumbnails.bind("click", function() {
        var e = $(this).attr("src").split("?")[0].split("."),
            t = e.pop(),
            i = e.pop().replace(/_[a-zA-Z0-9@]+$/, ""),
            n = e.join(".") + "." + i + "." + t;
        void 0 !== variantImages[n] && productOptions.forEach(function(e, t) {
            optionValue = variantImages[n]["option-" + t], null !== optionValue && $(".single-option-selector:eq(" + t + ") option").filter(function() {
                return $(this).text() === optionValue
            }).length && $(".single-option-selector:eq(" + t + ")").val(optionValue).trigger("change")
        })
    })
}), $(document).ready(function() {
    $("#SortTags").length && (jQuery.expr[":"].icontains = function(e, t, i) {
        return jQuery(e).text().toUpperCase().indexOf(i[3].toUpperCase()) >= 0
    }, $("#SortTags option:icontains(nouveau-produit)").remove(), $("#SortTags option:icontains(new-product)").remove())
}), $(document).ready(function() {
    window.location.href.indexOf("challenge#contact_form") > -1 && window.scrollTo(0, 0)
}), $(document).ready(function() {
    $(".form-success-modal").length && setTimeout(function() {
        $(".form-success-modal").fadeOut()
    }, 5e3)
}), $(document).ready(function() {
    if (document.getElementById("playpause")) {
        document.getElementById("playpause").addEventListener("click", function() {
            slideshowVideo.paused ? slideshowVideo.play() : slideshowVideo.pause()
        }), slideshowVideo = document.getElementById("slideshow-video-bg")
    }
});
var is_loader = '<?xml version="1.0" encoding="utf-8"?> <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="154px" height="154px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"> <g transform="rotate(0 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-3.2407407407407405s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(45 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-2.7777777777777777s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(90 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-2.314814814814815s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(135 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-1.8518518518518516s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(180 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-1.3888888888888888s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(225 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-0.9259259259259258s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(270 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-0.4629629629629629s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(315 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="0s" repeatCount="indefinite"></animate> </rect> </g> ></svg>';

function ScrollExecute() {
    if ($(document).height() - 800 < $(document).scrollTop() + $(window).height()) {
        var e = $("#more").last(),
            t = $("#more a").last().attr("href");
        e.length > 0 && "none" != e.css("display") && $.ajax({
            type: "GET",
            url: t,
            beforeSend: function() {
                e.clone().empty().insertAfter(e).append(is_loader), e.hide()
            },
            success: function(t) {
                e.next().remove();
                var i = $(t).find("#append-data-here").html(),
                    n = $(t).find("#more").html();
                $("#append-data-here").append(i), void 0 !== n && $("#more").html(n).show()
            },
            dataType: "html"
        })
    }
}
$(document).ready(function() {
    $(".owl-carousel").owlCarousel({
        loop: !0,
        responsiveClass: !0,
        responsive: {
            0: {
                items: 1,
                nav: !0
            },
            600: {
                items: 3,
                nav: !1
            },
            1000: {
                items: 4,
                nav: !0,
                loop: !1
            }
        }
    })
}), $(document).ready(function() {
    if ($(".template-product").length > 0) {
        var e = $(".tabs");
        e.find("a").on("click", function(t) {
            t.preventDefault(), e.find(".current").removeClass("current"), $(this).addClass("current");
            var i = $(this.hash),
                n = (i.height(), $(".tab-content"));
            i.siblings(":visible").fadeOut("fast"), n.animate({
                height: "auto"
            }, 300, function() {
                i.fadeIn("fast")
            })
        }).first().click()
    }
});